import EmailTransfer from '../../../assets/emailTransfer.svg';

const EmailTransferIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return <EmailTransfer {...props} />;
};

export default EmailTransferIcon;
